export default __webpack_public_path__ + "pdf/Matthew_Taliaferro.8c91a7d.pdf";